import '../store/auth.js';
import router from './router.js';
import ACLService from '../services/ACLService';
import { setProfile } from '@/api';
import { setIv } from '../api';
import mutations from '@/store/mutations';

/* eslint-disable */
export default {
  // auth({ store, next, to }) {
  auth({ store, next, to }) {
    if (!store.getters['auth/isLoggedIn']) {
      next('/login');
    }
    next();
  },
  guest({ store, next }) {
    if (store.getters['auth/isLoggedIn']) {
      next('/');
    }
  },
  async SSHCFCheckAccess({ store }) {
    const res = await store.dispatch('sshcf/getMyAccess');
    if (!res.data.is_valid) {
      router.push('/sshcf/login?valid=0');
    }
  },
  checkMiddleWare({ to, store, next }) {
    switch (to.meta.middleware) {
      case 'auth':
        this.auth({ store, next, to });
        break;
      case 'guest':
        this.guest({ store, next });
        break;
    }
  },
  // register({ store, next }) {
  register({ store }) {
    router.beforeEach(async (to, from, next) => {
      if ('token' in to.query) {
        store.dispatch('auth/logout');
        setIv(to.query.iv);
      }
      // set isAdhoc false
      if (from.name === 'spendingCreate' || from.name == null) {
        localStorage.setItem('isAdhoc', false);
      }
      // if (from.name !== 'one-pager' && from.name !== 'spending') {
      //   localStorage.removeItem('divisionObj');
      //   localStorage.removeItem('deptObj');
      //   localStorage.removeItem('houseObj');
      //   localStorage.removeItem('boObj');
      //   localStorage.removeItem('prevFilter');
      //   localStorage.removeItem('prevIO');
      //   localStorage.setItem('fromDetail', false);
      //   localStorage.removeItem('idItem');
      //   localStorage.removeItem('prevYear');
      // } else {
      //   localStorage.setItem('fromDetail', true);
      // }
      let isDetailFromDashboard = from.name === 'sshcp_dashboard' && 'typeFilter' in to.query;
      if (!isDetailFromDashboard) {
        store.commit('sshcp/set', {
          filter: {
            start_created_date: '',
            end_created_date: '',
            start_submitted_date: '',
            end_submitted_date: '',
            start_approved_date: '',
            end_approved_date: '',
            house: null,
            region: null,
            district: null,
            type_of_activity: null,
            status: null,
            isSubmit: true
          }
        });
      }
      await this.checkMiddleWare({ to, store, next });
      let path = to.fullPath.split('/');
      let beforePath = from.fullPath.split('/');
      if (path[2] !== beforePath[2]) {
        store.commit('pagination/RESET_PREV_PAGE', {
          name: to.name,
          path: to.fullPath,
          beforePath: from.fullPath
        });
        store.commit('pagination/RESET_PREV_PERPAGE', {
          name: to.name,
          path: to.fullPath,
          beforePath: from.fullPath
        });
      }

      if (to.meta.isRequireAccess) {
        await this.SSHCFCheckAccess({ store });
      }

      next();
    });
    router.afterEach(async (to, from) => {
      const editCSS = document.createElement('style');
      // const app = document.getElementById('inspire');
      editCSS.innerHTML = '#inspire {background: #f0f2f7 !important;}';
      document.body.appendChild(editCSS);
      const profile = JSON.parse(localStorage.getItem('profile'));
      const profile_id = localStorage.getItem('profile_id');
      setProfile(profile_id);
      if (to.meta.middleware === 'auth') {
        await store.dispatch('auth/getRoleConfig', profile).then(res => {
          if (res.code === 200) {
            store.commit(`auth/${mutations.SET_USER_ROLE}`, res.data);
            const permissions = store.getters['auth/permissions'];
            const acl = new ACLService(permissions);
            const hasPermissions = acl.checkRoutePermissions(to);

            if (!hasPermissions) {
              router.push({
                path: '/unauthorized',
                params: {
                  error: 401
                }
              });
            }
          } else if (res.response.data.code === 401) {
            store.dispatch('auth/logout');
            router.push({
              path: '/login',
              params: {
                error: 401
              }
            });
          }
        });
      }
    });
  }
};
